import { AccessBadge } from "~/pages/manifold-nextgen/components/AccessBadge";
import { ShareLevel } from "~/services/projects";

const ACCESS_LEVEL_LABEL: Record<ShareLevel, string> = {
  [ShareLevel.OWNER]: "Owner",
  [ShareLevel.USER]: "User",
};

interface ProjectAccessBadgeProps {
  accessLevel: ShareLevel | null;
}

export function ProjectAccessBadge({ accessLevel }: ProjectAccessBadgeProps) {
  return <AccessBadge label={accessLevel ? ACCESS_LEVEL_LABEL[accessLevel] : null} />;
}
